import React, { useState, useRef, useEffect } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';

const Select = ({
  selected,
  onChange,
  options = [],
  placeholder = 'Pasirinkite',
  allowNullOption = true,
  className = '',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className={`relative ${className}`} ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className={`w-full px-4 py-3 border border-gray-500 text-sm text-left cursor-pointer bg-white
          ${
            isOpen
              ? 'rounded-t-[1.4rem] rounded-b-none border-b-gray-500'
              : 'rounded-full'
          }
        `}
      >
        {selected?.label || placeholder}
        <span className="float-right">&#9662;</span>
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 w-full bg-white border border-t-0 border-gray-500 rounded-b-[1.4rem] z-10 ">
            {allowNullOption && (
              <div
                onClick={() => handleSelect(null)}
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
              >
                {placeholder}
              </div>
            )}
            {options.map((option) => (
              <div
                key={option.value}
                onClick={() => handleSelect(option)}
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
              >
                {option.label}
              </div>
            ))}{' '}
        </div>
      )}
    </div>
  );
};

export default Select;
